import React from "react";
import { CtaButton } from "./CtaButton";
type TransformCtaProps = {
  label: string;
  dark?: boolean;
  note?: string;
};
export function TransformCta({
  label,
  dark = false,
  note
}: TransformCtaProps) {
  return <div className="mx-auto mt-10 w-full max-w-xl" data-id="element-361" data-mp="2p9jbb1awmoui">
      <CtaButton label={label} data-id="element-362" data-mp="2tc7ht2c5bjob" />
      <p className={`mt-3 text-center text-sm ${dark ? "text-brand-100" : "text-ink/60"}`} data-id="element-363" data-mp="2tcftws0g2kyg">
        {note ?? "Instant access · One-time payment of $27 · 7-day guarantee"}
      </p>
    </div>;
}